"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _getCountryOptions = require("./getCountryOptions");

var phoneOptions = [];

var _default = function _default(phoneData) {
  if (phoneOptions.length) {
    return phoneOptions;
  }

  var countryOptions = (0, _getCountryOptions.getCountryOptions)();
  phoneOptions = countryOptions.filter(function (option) {
    return phoneData.find(function (c) {
      return c.iso2 === option.value;
    });
  }).map(function (option) {
    var dialCode = phoneData.find(function (c) {
      return c.iso2 === option.value;
    }).dialCode;
    return Object.assign({}, option, {
      text: option.text + " +" + dialCode
    });
  });
  return phoneOptions;
};

exports.default = _default;
module.exports = exports.default;